import { QBtn as e, QIcon as t, QInput as n, debounce as r } from "quasar";
import { computed as i, createBlock as a, createCommentVNode as o, createElementBlock as s, createElementVNode as c, createVNode as l, defineComponent as u, nextTick as d, normalizeClass as f, onMounted as p, openBlock as m, ref as h, toDisplayString as g, unref as _, watchEffect as v, withCtx as y } from "vue";
import { SocialLinkUtils as b } from "@utils/string-utils";
import { useI18n as x } from "vue-i18n";
//#region src/embeds/facebook-embed.vue?vue&type=script&setup=true&lang.ts
var S = { class: "mb-8" }, C = ["data-href"], w = ["data-href"], T = /* @__PURE__ */ u({
	__name: "facebook-embed",
	props: {
		postUrl: { default: "" },
		embedType: { default: "" }
	},
	setup(e) {
		let t = h({ scriptLoaded: !1 }), n = () => {
			let e = document.createElement("script");
			e.src = "https://connect.facebook.net/de_DE/sdk.js#xfbml=1&version=v7.0", e.crossOrigin = "anonymous", e.defer = !0, document.body.appendChild(e), t.value.scriptLoaded = !0;
		};
		return p(() => {
			t.value.scriptLoaded ? window.FB.XFBML.parse() : (delete window.FB, n());
		}), (t, n) => (m(), s("div", S, [
			n[0] ||= c("div", { id: "fb-root" }, null, -1),
			e.embedType === "posts" ? (m(), s("div", {
				key: 0,
				class: "fb-post",
				"data-href": e.postUrl
			}, null, 8, C)) : o("", !0),
			e.embedType === "videos" || e.embedType === "reel" ? (m(), s("div", {
				key: 1,
				class: "fb-video",
				"data-href": e.postUrl,
				"data-width": "500",
				"data-allowfullscreen": "true",
				"data-autoplay": "false",
				"data-show-captions": "true"
			}, null, 8, w)) : o("", !0)
		]));
	}
}), E = { class: "instagram-embed mb-8" }, D = ["innerHTML"], O = /* @__PURE__ */ u({
	__name: "instagram-embed",
	props: {
		postId: { default: "" },
		postType: { default: "" }
	},
	setup(e) {
		let t = e, n = h({
			scriptLoaded: !1,
			scriptLoading: !1
		}), r = h(""), i = async () => {
			r.value = `
          <blockquote class="instagram-media"
                      data-instgrm-permalink="https://www.instagram.com/${t.postType}/${t.postId}/?utm_source=ig_embed&amp;utm_campaign=loading"
                      data-instgrm-version="14">
            <a href="https://www.instagram.com/${t.postType}/${t.postId}/?utm_source=ig_embed&amp;utm_campaign=loading" target="_blank"></a>
          </blockquote>`, await d(() => {
				n.value.scriptLoading = !1, n.value.scriptLoaded = !0, window.instgrm.Embeds.process();
			});
		}, a = () => {
			n.value.scriptLoading = !0;
			let e = document.createElement("script");
			e.crossOrigin = "anonymous", e.defer = !0, e.src = "//www.instagram.com/embed.js", e.onload = () => i(), document.body.appendChild(e);
		};
		return p(() => {
			a();
		}), (e, t) => (m(), s("div", E, [c("div", { innerHTML: r.value }, null, 8, D)]));
	}
}), k = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, A = {}, j = { class: "flex flex-center placeholder-embed" };
function M(e, t) {
	return m(), s("div", j);
}
var N = /* @__PURE__ */ k(A, [["render", M], ["__scopeId", "data-v-0f524864"]]), P = { class: "mb-8" }, F = ["cite", "data-video-id"], I = ["cite", "data-unique-id"], L = /* @__PURE__ */ u({
	__name: "tiktok-embed",
	props: {
		postUrl: { default: "" },
		postId: { default: "" },
		embedType: { default: "" },
		accountName: { default: "" }
	},
	setup(e) {
		return p(() => {
			let e = document.createElement("script");
			e.setAttribute("src", "https://www.tiktok.com/embed.js"), e.setAttribute("async", ""), e.setAttribute("id", "tiktok-script"), document.head.appendChild(e);
		}), (t, n) => (m(), s("div", P, [!e.embedType || e.embedType === "video" ? (m(), s("blockquote", {
			key: 0,
			class: "tiktok-embed",
			cite: e.postUrl,
			"data-video-id": e.postId,
			style: {
				"max-width": "605px",
				"min-width": "325px"
			}
		}, [...n[0] ||= [c("section", null, null, -1)]], 8, F)) : (m(), s("blockquote", {
			key: 1,
			class: "tiktok-embed",
			cite: e.postUrl,
			"data-unique-id": e.accountName,
			"data-embed-type": "creator",
			style: {
				"max-width": "605px",
				"min-width": "325px"
			}
		}, [...n[1] ||= [c("section", null, null, -1)]], 8, I))]));
	}
}), R = ["innerHTML"], z = /* @__PURE__ */ u({
	__name: "tracdelight-embed",
	props: {
		accessKey: { default: "" },
		widgetId: { default: "" }
	},
	setup(e) {
		let t = e, n = h({
			scriptLoaded: !1,
			scriptLoading: !1
		}), r = h(""), i = async () => {
			r.value = `<div class="td-widget" data-td-args="{'widget':'${t.widgetId}'}"></div>`, await d(() => {
				n.value.scriptLoading = !1, n.value.scriptLoaded = !0, window.tracdelight.parse();
			});
		}, a = () => {
			n.value.scriptLoading = !0;
			let e = document.createElement("script");
			e.defer = !0, e.src = `https://scripts.tracdelight.io/tracdelight.js?accesskey=${t.accessKey}`, e.onload = () => i(), document.body.appendChild(e);
		};
		return p(() => {
			a();
		}), (e, t) => (m(), s("div", null, [c("div", {
			class: "tracdelight-embed",
			innerHTML: r.value
		}, null, 8, R)]));
	}
}), B = { class: "mb-8" }, V = { class: "twitter-tweet" }, H = ["href"], U = /* @__PURE__ */ u({
	__name: "twitter-embed",
	props: {
		accountName: { default: "" },
		tweetId: { default: "" }
	},
	setup(e) {
		let t = e, n = h({ scriptLoaded: !1 }), r = i(() => `https://twitter.com/${t.accountName}/status/${t.tweetId}`), a = () => {
			let e = document.createElement("script");
			e.src = "https://platform.twitter.com/widgets.js", e.crossOrigin = "anonymous", e.defer = !0, document.body.appendChild(e), n.value.scriptLoaded = !0;
		};
		return p(() => {
			n.value.scriptLoaded && window.twttr ? window.twttr?.widgets.load() : a();
		}), (e, t) => (m(), s("div", B, [c("div", null, [c("blockquote", V, [c("a", { href: r.value }, null, 8, H)])])]));
	}
}), W = { class: "mb-8" }, G = [
	"cite",
	"data-video-id",
	"data-short-id"
], K = ["src"], q = /* @__PURE__ */ u({
	__name: "youtube-embed",
	props: {
		embedType: { default: "" },
		postUrl: { default: "" },
		postId: { default: "" }
	},
	setup(e) {
		return (t, n) => (m(), s("div", W, [c("blockquote", {
			class: f(e.embedType === "video" ? "youtube-video" : "youtube-shorts"),
			cite: e.postUrl,
			"data-video-id": e.embedType === "video" ? e.postId : void 0,
			"data-short-id": e.embedType === "short" ? e.postId : void 0
		}, [c("iframe", {
			src: `https://www.youtube.com/embed/${e.postId}?feature=oembed`,
			style: {
				width: "100%",
				height: "100%"
			},
			frameborder: "0",
			referrerpolicy: "strict-origin-when-cross-origin",
			allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
			allowfullscreen: ""
		}, null, 8, K)], 10, G)]));
	}
}), J = { class: "q-ml-sm" }, Y = {
	key: 0,
	class: "row justify-center q-mt-sm"
}, X = {
	messages: {
		en: { social: {
			socialScriptBlock: "Insert social script",
			socialNotSupported: "This social embed is not supported.",
			showEmbed: "Show embed",
			hideEmbed: "Hide embed",
			contentBlockLabel: "Social"
		} },
		de: { social: {
			socialScriptBlock: "Social-Script einfügen",
			socialNotSupported: "Dieser Social-Embed wird nicht unterstützt.",
			showEmbed: "Embed anzeigen",
			hideEmbed: "Embed ausblenden",
			contentBlockLabel: "Social"
		} }
	},
	routes: [],
	contentBlocks: [{
		type: "SOCIAL",
		label: "social.contentBlockLabel",
		icon: "instagram",
		component: /* @__PURE__ */ k(/* @__PURE__ */ u({
			__name: "social-block",
			props: {
				block: {},
				locked: {
					type: Boolean,
					default: !1
				}
			},
			emits: ["update:block"],
			setup(u, { emit: f }) {
				let S = f, C = u, { t: w } = x(), { SocialLinkValidation: E, parseInstagram: D } = b, k = i({
					get: () => C.block,
					set: (e) => {
						S("update:block", e);
					}
				}), A = h(""), j = h({
					postId: "",
					postType: ""
				}), M = h({
					accountName: "",
					tweetId: ""
				}), P = h({
					postUrl: "",
					embedType: ""
				}), F = h({
					postUrl: "",
					postId: "",
					embedType: "",
					accountName: ""
				}), I = h({
					postUrl: "",
					embedType: "",
					postId: ""
				}), R = h({
					accessKey: "",
					widgetId: ""
				}), B = h(!1), V = () => {
					B.value = !B.value;
				};
				p(() => {
					V = r(V, 350);
				});
				let H = {
					socialName: "",
					postId: "",
					accountName: "",
					postUrl: "",
					embedType: "",
					accessKey: "",
					widgetId: ""
				};
				function W(e) {
					return e === "socialName" || e === "postId" || e === "accountName" || e === "postUrl" || e === "embedType" || e === "accessKey" || e === "widgetId";
				}
				let G = (e) => {
					let t = {
						...H,
						...e
					};
					for (let e in t) {
						if (!W(e)) continue;
						let n = t[e];
						typeof n == "string" && (k.value[e] = n);
					}
				}, K = () => {
					A.value = "", j.value = {
						postId: "",
						postType: ""
					}, M.value = {
						accountName: "",
						tweetId: ""
					}, P.value = {
						postUrl: "",
						embedType: ""
					}, F.value = {
						postUrl: "",
						postId: "",
						embedType: "",
						accountName: ""
					}, I.value = {
						postUrl: "",
						embedType: "",
						postId: ""
					}, k.value.socialName = "", k.value.postId = "", delete k.value.accountName, delete k.value.postUrl, delete k.value.embedType;
				}, X = (e) => {
					if (E.isInstagram(e)) {
						A.value = "instagram";
						let t = D(e);
						t ? (j.value.postType = t.postType, j.value.postId = t.postId, G({
							socialName: t.socialName,
							postId: t.postId
						})) : j.value.postType = "p";
					} else if (E.isTwitter(e)) {
						A.value = "twitter";
						let t = b.parseTwitter(e);
						t && (M.value.accountName = t.accountName, M.value.tweetId = t.postId, G({
							socialName: t.socialName,
							accountName: t.accountName,
							postId: t.postId
						}));
					} else if (E.isTiktok(e)) {
						A.value = "tiktok";
						let t = b.parseTiktok(e);
						t && (F.value.postUrl = t.postUrl, F.value.postId = t.postId, F.value.accountName = t.accountName, F.value.embedType = t.embedType, G({
							socialName: t.socialName,
							postUrl: t.postUrl,
							postId: t.postId,
							accountName: t.accountName,
							embedType: t.embedType
						}));
					} else if (E.isFacebook(e)) {
						A.value = "facebook";
						let t = b.parseFacebook(e);
						if (t) return P.value.postUrl = t.postUrl, P.value.embedType = t.embedType, G({
							socialName: t.socialName,
							embedType: t.embedType,
							postUrl: t.postUrl
						});
					} else if (E.isYoutube(e)) {
						A.value = "youtube";
						let t = b.parseYoutube(e);
						if (t) return I.value.postUrl = t.postUrl, I.value.embedType = t.embedType, I.value.postId = t.postUrl, G({
							socialName: t.socialName,
							embedType: t.embedType,
							postUrl: t.postUrl,
							postId: t.postId
						});
					} else if (E.isTracdelight(e)) {
						A.value = "tracdelight";
						let t = b.parseTracdelight(e);
						t && (R.value.accessKey = t.accessKey, R.value.widgetId = t.widgetId, G({
							socialName: t.socialName,
							accessKey: t.accessKey,
							widgetId: t.widgetId
						}));
					} else K();
				}, Z = () => {
					B.value = !1;
				}, Q = (e) => {
					X(e);
				};
				return v(() => {
					Q(k.value.content), d(() => B.value = k.value.socialName !== ""), Z();
				}), (r, i) => (m(), s("div", null, [
					l(_(n), {
						modelValue: k.value.content,
						"onUpdate:modelValue": i[0] ||= (e) => k.value.content = e,
						disabled: u.locked,
						type: "textarea",
						filled: "",
						placeholder: _(w)("social.socialScriptBlock"),
						rows: "3",
						outlined: ""
					}, null, 8, [
						"modelValue",
						"disabled",
						"placeholder"
					]),
					l(_(e), {
						outline: "",
						color: "black",
						class: "q-mt-md q-mb-sm",
						disable: !k.value.socialName,
						onClick: _(V)
					}, {
						default: y(() => [B.value ? B.value ? (m(), a(_(t), {
							key: 1,
							color: "primary",
							name: "eye-off"
						})) : o("", !0) : (m(), a(_(t), {
							key: 0,
							color: "primary",
							name: "eye"
						})), c("span", J, g(B.value ? _(w)("social.hideEmbed") : _(w)("social.showEmbed")), 1)]),
						_: 1
					}, 8, ["disable", "onClick"]),
					B.value ? (m(), s("div", Y, [A.value === "instagram" ? (m(), a(O, {
						key: 0,
						"post-id": j.value.postId,
						"post-type": j.value.postType
					}, null, 8, ["post-id", "post-type"])) : A.value === "twitter" ? (m(), a(U, {
						key: 1,
						"account-name": M.value.accountName,
						"tweet-id": M.value.tweetId
					}, null, 8, ["account-name", "tweet-id"])) : A.value === "facebook" && B.value ? (m(), a(T, {
						key: 2,
						"embed-type": P.value.embedType,
						"post-url": P.value.postUrl
					}, null, 8, ["embed-type", "post-url"])) : A.value === "tiktok" ? (m(), a(L, {
						key: 3,
						"post-url": F.value.postUrl,
						"post-id": F.value.postId,
						"embed-type": F.value.embedType,
						"account-name": F.value.accountName
					}, null, 8, [
						"post-url",
						"post-id",
						"embed-type",
						"account-name"
					])) : A.value === "youtube" ? (m(), a(q, {
						key: 4,
						"post-url": I.value.postUrl,
						"embed-type": I.value.embedType,
						"post-id": I.value.postId
					}, null, 8, [
						"post-url",
						"embed-type",
						"post-id"
					])) : A.value === "tracdelight" ? (m(), a(z, {
						key: 5,
						"access-key": R.value.accessKey,
						"widget-id": R.value.widgetId
					}, null, 8, ["access-key", "widget-id"])) : (m(), a(N, {
						key: 6,
						class: "placeholder-embed"
					}))])) : o("", !0)
				]));
			}
		}), [["__scopeId", "data-v-f65d9ab8"]]),
		defaultValue: {
			type: "SOCIAL",
			content: "",
			socialName: "",
			postId: ""
		}
	}]
};
//#endregion
export { X as socialModule };

//# sourceMappingURL=index.es.js.map